module.exports = __webpack_public_path__ + "img/logo.72566b03.png";